import type { BillPosition } from '../../api/bills';
import * as t from '../../translations/Bills.ts';

export const positions: BillPosition[] = ['support', 'oppose', 'neutral'];

/** One colour per position, shared by the filter chips and the row pills so no legend is needed. */
export const positionStyles: Record<BillPosition, { pill: string; dot: string; active: string; idle: string }> = {
    support: {
        pill: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
        dot: 'bg-emerald-500',
        active: 'border-emerald-600 bg-emerald-600 text-white',
        idle: 'border-emerald-200 bg-emerald-50 text-emerald-800 hover:border-emerald-300 hover:bg-emerald-100'
    },
    oppose: {
        pill: 'bg-red-50 text-red-700 ring-red-200',
        dot: 'bg-red-500',
        active: 'border-red-600 bg-red-600 text-white',
        idle: 'border-red-200 bg-red-50 text-red-800 hover:border-red-300 hover:bg-red-100'
    },
    neutral: {
        pill: 'bg-slate-100 text-slate-700 ring-slate-200',
        dot: 'bg-slate-400',
        active: 'border-slate-700 bg-slate-700 text-white',
        idle: 'border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300 hover:bg-slate-100'
    }
};

export function positionLabel(position: BillPosition): string {
    if (position === 'support') return t.Position_Support();
    if (position === 'oppose') return t.Position_Oppose();
    return t.Position_Neutral();
}
